import { useQueryClient } from '@tanstack/react-query';
import {
    PaymentPolicyTimeUnitInterval,
    getRepositoryQueryKey,
    useRepositoryMutation,
} from '@mews-commander/data-access';
import { useCurrentRateGroupContext, useCurrentServiceIdContext } from '../contexts';

export const usePaymentPoliciesValidate = (policyOverrideId?: string) => {
    const { id: rateGroupId } = useCurrentRateGroupContext();
    const serviceId = useCurrentServiceIdContext();

    const queryClient = useQueryClient();
    const validationMutation = useRepositoryMutation('paymentAndCancellationPolicies', 'validate');

    return async (
        timeUnitIntervals: Array<PaymentPolicyTimeUnitInterval>,
        options?: Parameters<typeof validationMutation.mutate>[1]
    ) => {
        const parameters = {
            policyOverrideId,
            rateGroupId,
            serviceId,
            timeUnitIntervals,
        };

        const queryKey = getRepositoryQueryKey('paymentAndCancellationPolicies', 'validate', parameters);

        return validationMutation.mutateAsync(parameters, {
            ...options,
            onSuccess: (data, ...rest) => {
                queryClient.setQueryData(queryKey, () => data);
                options?.onSuccess?.(data, ...rest);
            },
        });
    };
};
